export default __webpack_public_path__ + "static/opposite-instagram-a1fb5f37f2f98f38fa82a902eeb6eb7a.gif";